import React from 'react';
import { FaLeaf, FaWind, FaBroom, FaCheckCircle } from 'react-icons/fa';
import ContactForm from '../components/ContactForm'; // justera sökvägen om den ligger annorlunda
import { Helmet } from 'react-helmet';  // Importera Helmet

const Lovblasning = () => {
  return (
    <>
    <Helmet>
            <title>Lövblåsning & Trädgårdsstädning – Provalt Service AB</title>
            <meta name="description" content="Vi ser till att din trädgård är fri från löv och kvistar under hösten. Effektiv lövblåsning som håller dina ytor rena och snygga." />
          <link rel="canonical" href="https://provalt.se/lovblasning" />
          </Helmet>
      <section
        className="relative h-[50vh] bg-cover bg-center flex items-center justify-center text-white"
        style={{
          backgroundImage: "url('/images/gardening/provalt-lövblåsning.webp')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0" />
        <div className="relative z-10 text-center p-6 bg-black bg-opacity-30">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Lövblåsning</h1>
          <p className="text-xl md:text-2xl font-semibold">
            Håll rent och säkert i höst – snabb, effektiv och miljövänlig lövhantering
          </p>
        </div>
      </section>

      <section className="py-16 px-6 md:px-12 bg-green-100 text-gray-800">
        <div className="max-w-6xl mx-auto space-y-8">
          <h2 className="text-3xl font-bold">Professionell lövblåsning för alla miljöer</h2>
          <p className="text-lg">
            Under hösten kan löv snabbt täcka gångvägar, uppfarter, gräsmattor och entréer. Det ser inte bara stökigt ut – blöta löv ökar halkrisken, blockerar avlopp och kan ge fuktskador om de inte tas om hand i tid. Vi erbjuder en komplett lövblåsningstjänst som håller dina ytor rena, trygga och välskötta.
          </p>

          <h3 className="text-2xl font-semibold pt-4">Vi tar hand om löven – snabbt och noggrant</h3>
          <p className="text-lg">
            Med våra tystgående och kraftfulla lövblåsare städar vi effektivt bort löv från:
          </p>
          <ul className="list-disc list-inside text-lg pl-4 space-y-2">
            <li>Gångvägar och uppfarter</li>
            <li>Gräsmattor, rabatter och trädgårdar</li>
            <li>Uteplatser och terrasser</li>
            <li>Parkeringar och företagsområden</li>
            <li>Gemensamma ytor i bostadsrättsföreningar</li>
          </ul>

          <div className="flex items-start pt-6">
            <FaWind className="text-yellow-600 w-8 h-8 mr-4 mt-1" />
            <div>
              <h3 className="text-xl font-semibold">Tystgående och miljövänliga maskiner</h3>
              <p>Vi använder el- och batteridrivna lövblåsare som ger minimalt buller och noll utsläpp – perfekt för bostadsområden.</p>
            </div>
          </div>

          <div className="flex items-start">
            <FaBroom className="text-gray-700 w-8 h-8 mr-4 mt-1" />
            <div>
              <h3 className="text-xl font-semibold">Rensning & bortforsling</h3>
              <p>Vi samlar upp löven, rensar hängrännor och avlopp vid behov, och transporterar bort lövavfallet på ett miljövänligt sätt.</p>
            </div>
          </div>

          <div className="flex items-start">
            <FaLeaf className="text-green-600 w-8 h-8 mr-4 mt-1" />
            <div>
              <h3 className="text-xl font-semibold">Anpassad efter dina behov</h3>
              <p>Vi erbjuder både enstaka insatser och löpande avtal under hela hösten – alltid anpassat efter din fastighet och ditt schema.</p>
            </div>
          </div>
        </div>
      </section>

<section
      className="relative py-20 px-6 md:px-12 text-gray-900">
      {/* Vit overlay med transparens */}
      <div className="absolute inset-0 bg-white/90 backdrop-blur-sm"></div>

      <div className="relative max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
        {/* Textinnehåll */}
        <div className="space-y-8">
          <h2 className="text-3xl font-extrabold leading-tight">
            Varför välja oss för lövblåsning?
          </h2>
          <ul className="space-y-6 text-lg">
            <li className="flex items-start">
              <FaCheckCircle className="text-green-600 w-7 h-7 mr-4 mt-1" />
              <p>
                <strong>Snabba insatser:</strong> Vi rycker ut snabbt när löven faller som mest.
              </p>
            </li>
            <li className="flex items-start">
              <FaCheckCircle className="text-green-600 w-7 h-7 mr-4 mt-1" />
              <p>
                <strong>Skonsam utrustning:</strong> Vi blåser med omsorg om gräs, rabatter och känsliga ytor.
              </p>
            </li>
            <li className="flex items-start">
              <FaCheckCircle className="text-green-600 w-7 h-7 mr-4 mt-1" />
              <p>
                <strong>Helhetslösningar:</strong> Kombinera lövblåsning med våra andra tjänster för en komplett höst- och vinterskötsel.
              </p>
            </li>
          </ul>
        </div>

        {/* Formulär */}
        <div className="bg-white p-2 rounded-3xl shadow-xl max-w-md w-full mx-auto">
          <ContactForm service="Lövblåsning" />
        </div>
      </div>
    </section>

    </>
  );
};

export default Lovblasning;
